import DrawerAppBar from "../components/nav";
import Tokenomics from "../sections/Tokenomics";
import About from "../sections/about";
import Footer from "../sections/footer";
import Header from "../sections/header";
import HowToBuy from "../sections/howtobuy";


function Home(){
    return(
        <>  
            <DrawerAppBar />
            <Header />
            <About />
            <Tokenomics />
            <HowToBuy />
            <Footer />
        </>
    );
}

export default Home;